import React from 'react';
import CONSTANTS from './constants.js'
import './App.scss';

import SoundBox from './SoundBox'
import Display from './Display'
class App extends React.Component{
    constructor(props){
        super(props);
    }
    
    
    render(){
        let key = 0;
        const SOUNDBOXES = (sound) => {
            return (<SoundBox sound = {sound} keyPress = {CONSTANTS.KEY_PRESS[key]} key = {key++}/>);
        };
                    
      return (
        <div id='drum-machine' className='App container'>
            <h1 id='AppDrumHeader'>Fun Drum Machine </h1>
                <div id='AppComponentWrapper'>
                <div id='AppSoundWrapper'>
                    {CONSTANTS.SOUNDS.map(SOUNDBOXES)}
                </div>
                <div id='AppDisplayWrapper'>
                    <Display/>
                </div>
            </div>
                
        </div>
      );
    }
}

export default App;
